import React, { useEffect, useState, useContext } from "react";
import PageHeader from "../../pageheader/PageHeader";
import MenuAdmin from "../navAdmin/Menu";
import * as publicApi from "../../../service/publicApi";
import AutoComplete from "../../material/autoComplete/AutoComplete";
import Input from "../../material/input/Input";
import InputV2 from "../../material/input/InputV2";
import { PlusIcon, MinusIcon } from "@heroicons/react/24/outline";
import { useLocation, useNavigate } from "react-router-dom";
import * as AdminApi from "../../../service/adminApi";
import { HashLoader } from "react-spinners";
import CheckBoxV3 from "../../material/checkboxV3/CheckBoxV3";

import { CurrentUserContext } from "../../../App";
import Breadcrumb from "../../breadcrumb/breadcrumb";
import PageHeaderV2 from "../../pageheaderV2/PageHeaderV2";

function AddorEditHospital() {
  const { setIsMessage } = useContext(CurrentUserContext);

  const [titlepage, setTitlePage] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const [permissionResetKey, setPermissionResetKey] = useState(false);
  const [formState, setFormState] = useState({
    hospital_id: location?.state?.hospital_id || "",
    ip_address: location?.state?.ip_address || "",
    client_id: location?.state?.client_id || "",
    client_secret: location?.state?.client_secret || "",
    // send: location.state?.send || {
    //   url: "",
    //   header_list: [
    //     {
    //       key: "",
    //       value: "",
    //     },
    //   ],
    // },
    // revoke: location.state?.revoke || {
    //   url: "",
    //   header_list: [
    //     {
    //       key: "",
    //       value: "",
    //     },
    //   ],
    // },
  });
  const [hospitalList, setHospitalList] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getHospitalList();
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    location.state?.mode
      ? location.state?.mode === "edit"
        ? setTitlePage("แก้ไขโรงพยาบาล")
        : setTitlePage("เพิ่มโรงพยาบาล")
      : setTitlePage("เพิ่มโรงพยาบาล");
  }, []);

  useEffect(() => {
    if (location.state?.data) {
      setFormState(location.state.data);
    }
  }, []);

  const getHospitalList = async () => {
    setLoading(true);
    let res = await publicApi.getHospitalList();
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setHospitalList(
          res["data"]["hospital_list"].map((item) => {
            return {
              id: item["hospital_id"],
              name: item["hospital_name"],
            };
          }),
        );
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const ManageSettingSaveWebHook = async () => {
    setLoading(true);
    let res = await AdminApi.saveWebHook(formState, permissionResetKey);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/admin/hospitalsetting");
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const UpdateSettingSaveWebHook = async (id) => {
    setLoading(true);
    let res = await AdminApi.updateWebHook(id, formState, permissionResetKey);
    setLoading(false);

    if (res) {
      if (res["data"]["code"] === 200) {
        setIsMessage({
          type: "success",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
        navigate("/admin/hospitalsetting");
      } else {
        setIsMessage({
          type: "warning",
          data: res["data"]["message_th"] || res["data"]["message"],
        });
      }
    } else {
      setIsMessage({
        type: "error",
        data: "เกิดปัญหาการใช้งาน กรุณาติดต่อเจ้าหน้าที่",
      });
    }
  };

  const handleChangeInputAutoSearch = (hospital_id) => {
    setFormState({
      ...formState,
      hospital_id: hospital_id,
    });
  };

  const onChange = (id, value) => {
    setFormState((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const handleChangeInputURL = (type, e) => {
    const insertFormState = { ...formState[type] }; //กรณีดึงค่าเดิม data type เป็น object   ถ้าจะดึงdata type array ต้องใช้ [...state.คีย์ที่ต้องการอัพเดท]

    if (type === "send") {
      //ทิค ไม่จำเป็นต้อง e.target.name ถ้าเข้าใจเรื่อง OOP แค่ทำให้มันดูยาก เฉยๆอิอิ    ก็อาจจะใช้ insertFormStateSend.url หรือ ['url']
      // setFormState({
      //     ...formState, send: {
      //         url: insertFormState[e.target.name] = e.target.value,
      //         header_list: insertFormState.header_list //ต้องdefault ค่าเก่าด้วย
      //     }
      // });

      // หรือวิธีที่ 2
      insertFormState[e.target.name] = e.target.value;

      setFormState({
        ...formState,
        [type]: insertFormState,
      });
    } else {
      // setFormState({
      //     ...formState, revoke: {
      //         url: insertFormState[e.target.name] = e.target.value,
      //         header_list: insertFormState.header_list //ต้องdefault ค่าเก่าด้วย
      //     }
      // });

      // วิธีที่สอง
      insertFormState[e.target.name] = e.target.value;

      setFormState({
        ...formState,
        [type]: insertFormState,
      });
    }
  };

  // const handleChangeInputHeader = (type, e, index) => {
  //   const insertFormState = { ...formState[type] };

  //   insertFormState["header_list"][index][e.target.name] = e.target.value;

  //   setFormState({
  //     ...formState,
  //     [type]: insertFormState,
  //   });
  // };

  // const addHeaderKey = (type) => {
  //   let newHeaderKey = {
  //     key: "",
  //     value: "",
  //   };
  //   const updatedFormState = { ...formState[type] };
  //   if (type === "send") {
  //     updatedFormState["header_list"].push(newHeaderKey);

  //     setFormState({
  //       ...formState,
  //       send: updatedFormState,
  //     });
  //   } else {
  //     updatedFormState["header_list"].push(newHeaderKey);

  //     setFormState({
  //       ...formState,
  //       revoke: updatedFormState,
  //     });
  //   }
  // };

  // const removeHeader = (type, item_remove) => {
  //   const updatedFormState = { ...formState[type] };

  //   if (type === "send") {
  //     updatedFormState["header_list"] = updatedFormState["header_list"].filter(
  //       (remove) => {
  //         return remove !== item_remove;
  //       }
  //     );
  //     setFormState({
  //       ...formState,
  //       [type]: updatedFormState,
  //     });
  //   } else {
  //     updatedFormState["header_list"] = updatedFormState["header_list"].filter(
  //       (remove) => {
  //         return remove !== item_remove;
  //       }
  //     );
  //     setFormState({
  //       ...formState,
  //       [type]: updatedFormState,
  //     });
  //   }
  // };

  const hadleSubmit = (action) => {
    if (action === "save") {
      if (formState.hospital_id === "") {
        setIsMessage({
          type: "warning",
          data: "กรุณากรอก เลือกโรงพยาบาลที่ต้องการ",
        });
        return;
      }

      if (formState.ip_address === "") {
        setIsMessage({
          type: "warning",
          data: "กรุณากรอก IP Address สำหรับการรับ - ส่งข้อมูลไปยังโรงพยาบาล",
        });
        return;
      }

      // if (formState.client_id === "") {
      //   setIsMessage("กรุณากรอก Client ID สำหรับการรับ - ส่งข้อมูลไปยังโรงพยาบาล");
      //   return;
      // }

      // if (formState.client_secret === "") {
      //   setIsMessage("กรุณากรอก Client Secret สำหรับการรับ - ส่งข้อมูลไปยังโรงพยาบาล");
      //   return;
      // }

      // for (let send_header_list of formState.send.header_list) {
      //   if (send_header_list["key"] === "") {
      //     setIsMessage("กรุณากรอก Key ให้ครบถ้วน");
      //     return;
      //   }
      //   if (send_header_list["value"] === "") {
      //     setIsMessage("กรุณากรอก value ให้ครบถ้วน");
      //     return;
      //   }
      // }

      // if (formState.revoke.url === "") {
      //   setIsMessage("กรุณากรอก URL สำหรับการเรียกคืนข้อมูลจากโรงพยาบาล");
      //   return;
      // }

      // for (let revoke_header_list of formState.revoke.header_list) {
      //   if (revoke_header_list["key"] === "") {
      //     setIsMessage("กรุณากรอก Key ให้ครบถ้วน");
      //     return;
      //   }
      //   if (revoke_header_list["value"] === "") {
      //     setIsMessage("กรุณากรอก value ให้ครบถ้วน");
      //     return;
      //   }
      // }

      ManageSettingSaveWebHook();
    } else if (action === "edit") {
      if (formState.hospital_id === "") {
        setIsMessage({
          type: "warning",
          data: "กรุณากรอก เลือกโรงพยาบาลที่ต้องการ",
        });
        return;
      }

      if (formState.ip_address === "") {
        setIsMessage({
          type: "warning",
          data: "กรุณากรอก IP Address สำหรับการรับ - ส่งข้อมูลไปยังโรงพยาบาล",
        });
        return;
      }

      if (formState.client_id === "") {
        setIsMessage({
          type: "warning",
          data: "กรุณากรอก Client ID สำหรับการรับ - ส่งข้อมูลไปยังโรงพยาบาล",
        });
        return;
      }

      if (formState.client_secret === "") {
        setIsMessage({
          type: "warning",
          data: "กรุณากรอก Client Secret สำหรับการรับ - ส่งข้อมูลไปยังโรงพยาบาล",
        });
        return;
      }

      // for (let send_header_list of formState.send.header_list) {
      //   if (send_header_list["key"] === "") {
      //     setIsMessage("กรุณากรอก Key ให้ครบถ้วน");
      //     return;
      //   }
      //   if (send_header_list["value"] === "") {
      //     setIsMessage("กรุณากรอก value ให้ครบถ้วน");
      //     return;
      //   }
      // }

      // if (formState.revoke.url === "") {
      //   setIsMessage("กรุณากรอก URL สำหรับการเรียกคืนข้อมูลจากโรงพยาบาล");
      //   return;
      // }

      // for (let revoke_header_list of formState.revoke.header_list) {
      //   if (revoke_header_list["key"] === "") {
      //     setIsMessage("กรุณากรอก Key ให้ครบถ้วน");
      //     return;
      //   }
      //   if (revoke_header_list["value"] === "") {
      //     setIsMessage("กรุณากรอก value ให้ครบถ้วน");
      //     return;
      //   }
      // }
      UpdateSettingSaveWebHook(location.state?.id);
    }
  };

  const styles_tw = {
    container: "mx-48 md:mt-[15px] mt-[50px] md:mx-2",
    label_input:
      "md:text-[16px] text-[#2E2E2E] font-bold underline md:my-[5px] my-[10px]",
    bg_card:
      "bg-[#fff9e4] md:my-[10px] my-[20px] md:px-[20px] px-[50px] pt-[10px] pb-[20px] rounded-[20px]",
    line_storke: "border border-solid border-[#A2B5BC] md:my-[10px] my-[20px]",
    btn_add:
      "button-theme-pg bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl shadow-sm shadow-brand-cyan flex justify-center items-center md:text-[12px] text-[16px] md:h-[30px] md:w-[150px] h-[45px] w-[200px] md:gap-[5px] gap-[10px] text-[#526F65] ",
    btn_save:
      "button-theme-pg bg-gradient-to-r from-[#85DDDE] to-[#B9DFC5] rounded-3xl shadow-sm shadow-brand-cyan flex justify-center items-center md:text-[12px] text-[16px] md:w-[100px] md:h-[30px] h-[45px] w-[150px] md:gap-[5px] gap-[10px] text-[#526F65] ",
    grid_cols_three: "",
    icon_delete:
      "button-theme-pg bg-[#EA8D8D] md:p-1 md:stroke-[1px] p-2 rounded-full stroke-[#374957] stroke-[3px] hover:cursor-pointer",
  };

  return (
    <div>
      <PageHeaderV2 titlename={titlepage ?? ""} />
      {!loading ? (
        <div>
          <div className={styles_tw.label_input}>เลือกโรงพยาบาลที่ต้องการ</div>
          <AutoComplete
            id={formState.hospital_id}
            disabledLabel
            placeholder="พิมพ์ที่นี่เพื่อค้นหาชื่อโรงพยาบาล"
            list={hospitalList}
            callBack={(res) => {
              handleChangeInputAutoSearch(res["id"]);
            }}
          />

          <div class="rounded-[6px] border-[#E2E2E4] border w-full min-w-[400px] p-[17px_16px]">
            Ip Address
            <InputV2
              placeholder="Ip Address"
              value={formState.ip_address}
              onChangeEvt={(value) => onChange("ip_address", value)}
            />
            <div className="mt-[10px] w-full flex flex-row md:flex-col justify-center items-center gap-[10px]">
              <div className="flex flex-col w-full">
                Client Id
                <InputV2
                  placeholder="Client Id"
                  value={formState.client_id}
                  onChangeEvt={(value) => onChange("client_id", value)}
                  disabled={true}
                  style={{ width: "100%" }}
                />
              </div>
              <div className="flex flex-col w-full">
                Client Secret
                <InputV2
                  placeholder="Client Secret"
                  value={formState.client_secret}
                  onChangeEvt={(value) => onChange("client_secret", value)}
                  disabled={true}
                  style={{ width: "100%" }}
                />
              </div>
            </div>
          </div>

          {/* <div className={styles_tw.bg_card}>
            <div className={styles_tw.label_input}>
              URL สำหรับการรับ - ส่งข้อมูลไปยังโรงพยาบาล
            </div>
            <Input
              placeholder="URL"
              disabledLabel
              name="url"
              value={formState.send.url}
              validate={formState.send.url === "" ? true : false}
              onChangeEvt={(e) => {
                handleChangeInputURL("send", e);
              }}
            />
            {formState["send"]["header_list"].map((i, indx) => {
              return (
                <>
                  <div className={styles_tw.line_storke}></div>
                  <div className={styles_tw.label_input}>Header</div>
                  <div className="grid grid-cols-[auto_auto_50px] md:grid-cols-[auto_auto_30px] md:gap-2 gap-5 items-end">
                    <Input
                      placeholder="Key"
                      name="key"
                      value={i["key"]}
                      validate={i["key"] === "" ? true : false}
                      onChangeEvt={(e) => {
                        handleChangeInputHeader("send", e, indx);
                      }}
                    />
                    <Input
                      placeholder="Value"
                      name="value"
                      value={i["value"]}
                      validate={i["value"] === "" ? true : false}
                      onChangeEvt={(e) => {
                        handleChangeInputHeader("send", e, indx);
                      }}
                    />
                    {formState["send"]["header_list"].length !== 1 && (
                      <MinusIcon
                        className={styles_tw.icon_delete}
                        onClick={() => {
                          removeHeader("send", i);
                        }}
                      />
                    )}
                  </div>
                </>
              );
            })}
            <div className="flex justify-center items-center mt-[35px]">
              <button
                className={styles_tw.btn_add}
                onClick={() => {
                  addHeaderKey("send");
                }}
              >
                <PlusIcon className="stroke-[#526F65] stroke-[3px] md:w-[15px] w-[25px]" />
                <div>เพิ่ม Header</div>
              </button>
            </div>
          </div> */}

          {/* <div className={styles_tw.bg_card}>
            <div className={styles_tw.label_input}>
              URL สำหรับการเรียกคืนข้อมูลจากโรงพยาบาล
            </div>
            <Input
              placeholder="URL"
              disabledLabel
              name="url"
              value={formState.revoke.url}
              validate={formState.revoke.url === "" ? true : false}
              onChangeEvt={(e) => {
                handleChangeInputURL("revoke", e);
              }}
            />
            {formState["revoke"]["header_list"].map((i, indx) => {
              return (
                <>
                  <div className={styles_tw.line_storke}></div>
                  <div className={styles_tw.label_input}>Header</div>
                  <div className="grid grid-cols-[auto_auto_50px] md:grid-cols-[auto_auto_30px] md:gap-2 gap-5 items-end">
                    <Input
                      placeholder="Key"
                      name="key"
                      value={i["key"]}
                      validate={i["key"] === "" ? true : false}
                      onChangeEvt={(e) => {
                        handleChangeInputHeader("revoke", e, indx);
                      }}
                    />
                    <Input
                      placeholder="Value"
                      name="value"
                      value={i["value"]}
                      validate={i["value"] === "" ? true : false}
                      onChangeEvt={(e) => {
                        handleChangeInputHeader("revoke", e, indx);
                      }}
                    />
                    {formState["revoke"]["header_list"].length !== 1 && (
                      <MinusIcon
                        className={styles_tw.icon_delete}
                        onClick={() => {
                          removeHeader("revoke", i);
                        }}
                      />
                    )}
                  </div>
                </>
              );
            })}
            <div className="flex justify-center items-center mt-[35px]">
              <button
                className={styles_tw.btn_add}
                onClick={() => {
                  addHeaderKey("revoke");
                }}
              >
                <PlusIcon className="stroke-[#526F65] stroke-[3px] md:w-[15px] w-[25px]" />
                <div>เพิ่ม Header</div>
              </button>
            </div>
          </div> */}

          {location.state?.mode ? (
            <div>
              <CheckBoxV3
                id="checkbox3"
                value={permissionResetKey}
                setValue={setPermissionResetKey}
                label={<p>ยืนยันการ reset key</p>}
              />
            </div>
          ) : null}

          <div className="flex justify-center items-center md:mt-[15px] mt-[35px]">
            <button
              className={styles_tw.btn_save}
              onClick={() => {
                hadleSubmit(location.state?.mode ? "edit" : "save");
              }}
            >
              <div>{location.state?.mode ? "แก้ไข" : "บันทึก"}</div>
            </button>
          </div>
        </div>
      ) : (
        <HashLoader
          loading={true}
          style={{ display: "flex", justifyContent: "center", margin: "20px" }}
          color="#FF9768"
        />
      )}
    </div>
  );
}

export default AddorEditHospital;
